import { getCanvasDimensions } from './utils';

const getDimensions = (dimension) => ({
  size: dimension * 0.8,
  gutterSize: (dimension * 0.2) / 2
});

const scaleDimensions = (canvasDimensions) => ({
  width: getDimensions(canvasDimensions.width),
  height: getDimensions(canvasDimensions.height)
});


const getSourceModeSize = (scaledDimensions) => ({
  height: scaledDimensions.height.size,
  width: scaledDimensions.width.size
});

const getSourceModeOffset = (canvasOffset, scaledDimensions) => ({
  left: canvasOffset.left + scaledDimensions.width.gutterSize,
  top: canvasOffset.top + scaledDimensions.height.gutterSize
});

export function sourceModeDimensions() {
  const canvasDimensions = getCanvasDimensions();
  const scaledDimensions = scaleDimensions(canvasDimensions);

  const sourceModeSize = getSourceModeSize(scaledDimensions);
  const sourceModeOffset = getSourceModeOffset(canvasDimensions.offset, scaledDimensions);

  return {
    ...sourceModeSize,
    ...sourceModeOffset
  };
}



// WEBPACK FOOTER //
// ./src/ui/inline-text/source-mode-components/source-mode-dimensions.jsx